import React, {useContext, useState} from 'react';
import AuthContext from "../../Services/AuthContext";
import StyledModal from "../../Component/StyledModal";
import {InputAdornment, TextField} from "@mui/material";
import StyledSelect from "../../Component/StyledSelect";


function AddSeason(props) {
    const title = 'Dodaj Sezon';
    const description = 'Tutaj możesz dodać ograniczenie sezonu dla swoich wydarzeń.';

    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [quota, setQuota] = useState(0);
    const [organization, setOrganization] = useState({id: user.facilities[0]?.id, label: user.facilities[0]?.name});

    function _send() {
        const formData = {
            name: name,
            quota: quota
        };
        fetch(`/api/season/${organization.id}`, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                props.onSuccess(data);
                props.dismiss();
            })
            .catch(err => { console.log(err) })
    }

    return (<StyledModal isOpen={props.isOpen} title={title} description={description} send={_send} dismiss={props.dismiss}>
                <StyledSelect
                    name='name'
                    label='Organizacja'
                    value={organization}
                    onChange={(e, v) => setOrganization(v)}
                    items={user.facilities}
                />
                <TextField
                    onChange={(e) => setName(e.target.value)}
                    label='Nazwa'
                    value={name}
                    variant="outlined"
                    fullWidth
                />
                <TextField
                    type={'number'}
                    onChange={(e) => setQuota(e.target.value)}
                    label='Blokada'
                    value={quota}
                    variant="outlined"
                    fullWidth
                    slotProps={{
                        input: {
                            endAdornment: <InputAdornment position="end">dni</InputAdornment>,
                        },
                    }}
                />
        </StyledModal>);
}
export default AddSeason;